var _path, _path2, _path3, _path4, _path5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8NewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M44,24c0,11.046-8.954,20-20,20S4,35.046,4,24c0-2.216,0.36-4.348,1.026-6.341 C6.311,13.812,14.489,11,14.489,11s0.04-4.693,1.507-5.334C18.447,4.594,21.154,4,24,4C35.046,4,44,12.954,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16,8.594V5.675c-1.432,0.626-2.767,1.424-4,2.352V8.31l-0.206-0.128 c-3.105,2.399-5.483,5.683-6.753,9.483L12,13.32V18h4v-4.965L23.949,18H25v-2.609L21.171,13H25V9h-4.421L25,6.238V4.05 C24.667,4.034,24.338,4,24,4c-0.235,0-0.464,0.027-0.697,0.035L16,8.594z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M13,12v6h2v-6h10v-2H15V6.157c-0.689,0.348-1.36,0.725-2,1.148V10H9.729 c-0.613,0.625-1.174,1.299-1.701,2H13z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M11.641,13H9.898l-3.972,2.479c-0.229,0.484-0.437,0.977-0.627,1.481L11.641,13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M24.213,4.011L16.223,9h1.746L25,4.609V4.05C24.738,4.037,24.478,4.014,24.213,4.011z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "25,15.934 20.301,13 18.559,13 25,17.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "27.34,26.297 29.508,24.383 26.629,24.105 25.477,21.453 24.324,24.105 21.445,24.383 23.609,26.297 22.984,29.121 25.477,27.652 27.969,29.121"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "32.629,32.105 31.477,29.449 30.324,32.105 27.445,32.379 29.609,34.297 28.984,37.117 31.477,35.652 33.969,37.117 33.34,34.297 35.508,32.379"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "28.984,22.121 31.477,20.652 33.969,22.121 33.34,19.297 35.508,17.383 32.629,17.105 31.473,14.453 30.324,17.105 27.445,17.383 29.609,19.297"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "40.508,23.383 37.629,23.105 36.477,20.453 35.324,23.105 32.445,23.383 34.613,25.297 33.984,28.121 36.477,26.652 38.969,28.121 38.34,25.301"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "25.477,23.961 25.945,25.047 27.121,25.156 26.238,25.941 26.492,27.094 25.477,26.492 24.461,27.094 24.715,25.941 23.832,25.156 25.008,25.047"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "31.477,31.961 31.945,33.047 33.121,33.156 32.238,33.941 32.492,35.094 31.477,34.492 30.461,35.094 30.715,33.941 29.832,33.156 31.008,33.047"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "31.477,16.961 31.945,18.047 33.121,18.156 32.238,18.941 32.492,20.094 31.477,19.492 30.461,20.094 30.715,18.941 29.832,18.156 31.008,18.047"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "36.477,22.961 36.945,24.047 38.121,24.156 37.238,24.941 37.492,26.094 36.477,25.492 35.461,26.094 35.715,24.941 34.832,24.156 36.008,24.047"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8NewZealand);
export default __webpack_public_path__ + "static/media/icons8-new-zealand.1709df0e4feadc23b5ca1958f133ceb9.svg";
export { ForwardRef as ReactComponent };